import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=6f8d01dd&scoped=true&"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d01dd",
  null
  
)

export default component.exports